import loginCityAnimation from "assets/animations/loginCity.json";
import { ReactComponent as OnStreetHorizontalLogo } from "assets/images/onstreet-horizontal.svg";
import SecondaryBackButton from "components/BackButton/Secondary";
import SimpleLogo from "components/SimpleLogo";
import useLocalizedRoutes from "hooks/useLocalizedRoutes";
import { Heading } from "iparque-components";
import Lottie, { LottieRefCurrentProps } from "lottie-react";
import React, { ReactNode, useRef } from "react";
import { useTranslation } from "react-i18next";
import { isInternetExplorer } from "utils/browser";
import OldBrowserWarning from "../OldBrowserWarning";
import LoginForm from "./LoginForm";
import PasswordDefinitionForm from "./PasswordDefinitionForm";
import PasswordRecoveryForm from "./PasswordRecoveryForm";
import {
  FormContainer,
  StyledContentContainer,
  StyledFullPageContainer,
} from "./styles";
import TwoFactorAuthenticationForm from "./TwoFactorAuthenticationForm";

interface Props {
  screen:
    | "login"
    | "password-recovery"
    | "password-definition"
    | "two-factor-authentication";
}

interface ConditionalContent {
  backUrl: string;
  title: string;
  component: ReactNode;
}

const AuthenticationPage: React.FC<Props> = ({ screen }) => {
  const { t } = useTranslation();
  const lottieRef = useRef<LottieRefCurrentProps>(null);
  const { getLanguageRoute } = useLocalizedRoutes();
  const defaultBackUrl = getLanguageRoute("home");

  const { title, component } = ((): ConditionalContent => {
    if (screen === "login") {
      return {
        backUrl: defaultBackUrl,
        title: t("7861") /* Bem-vindo ao */,
        component: <LoginForm />,
      };
    }

    if (screen === "password-recovery") {
      return {
        backUrl: getLanguageRoute("login"),
        title: t("7879") /* Recuperar Senha */,
        component: <PasswordRecoveryForm />,
      };
    }

    if (screen === "password-definition") {
      return {
        backUrl: getLanguageRoute("login"),
        title: t("7879") /* Recuperar Senha */,
        component: <PasswordDefinitionForm />,
      };
    }

    if (screen === "two-factor-authentication") {
      return {
        backUrl: getLanguageRoute("login"),
        title: t("11876") /* Validação em dois passos */,
        component: <TwoFactorAuthenticationForm />,
      };
    }

    return { backUrl: defaultBackUrl, title: "", component: null };
  })();

  return (
    <StyledFullPageContainer>
      {isInternetExplorer && <OldBrowserWarning />}
      <SecondaryBackButton to={defaultBackUrl} />
      <StyledContentContainer>
        <SimpleLogo
          role="img"
          aria-labelledby={
            t(
              "10687"
            ) /* Logo da solução de gestão de estacionamento para concessionárias */
          }
          title={
            t(
              "10687"
            ) /* Logo da solução de gestão de estacionamento para concessionárias */
          }
        />
        <FormContainer>
          <Heading variant="h9">{title}</Heading>
          <OnStreetHorizontalLogo
            className="mt-10"
            role="img"
            aria-labelledby={
              t(
                "10687"
              ) /* Logo da solução de gestão de estacionamento para concessionárias */
            }
            title={
              t(
                "10687"
              ) /* Logo da solução de gestão de estacionamento para concessionárias */
            }
          />
          {component}
        </FormContainer>
      </StyledContentContainer>
      <Lottie
        lottieRef={lottieRef}
        animationData={loginCityAnimation}
        loop={false}
        autoplay
        role="img"
        className="login-animation"
        aria-labelledby={t("10693") /* Cidade inteligente */}
        title={t("10693") /* Cidade inteligente */}
      />
    </StyledFullPageContainer>
  );
};

export default AuthenticationPage;
